module.exports = __webpack_public_path__ + "img/aussie-rules.380de59d.svg";